import { render, staticRenderFns } from "./ForwardIcon.vue?vue&type=template&id=fc3d0b5c&"
import script from "./ForwardIcon.vue?vue&type=script&lang=js&"
export * from "./ForwardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports